import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { Printer, Trash2 } from 'react-feather';
import { authAxiosInstance } from '../../utils/axiosConfig';
import {
    deleteWriteOffSecond,
    fetchWriteOffSecond,
} from '../../app/api/writeOffSecond';

const ViewWriteOffSecond = () => {
    const [loading, setLoading] = useState(false);
    const [writeOffData, setWriteOffData] = useState([]);
    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    const getWriteOffSeconds = async (fetchPayload) => {
        try {
            setLoading(true);
            const cardResp = await fetchWriteOffSecond(fetchPayload);
            setWriteOffData(cardResp.data);
        } catch (error) {
            toast.error('Failed to fetch cutting cards');
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const cols = [
        {
            Header: 'Write Off Second No.',
            accessor: 'writeOffSecondNumber',
        },
        {
            Header: 'Cutting Card No',
            accessor: 'cuttingCardRef.cuttingCardNumber',
        },
        {
            Header: 'Quality',
            accessor: 'quality.name',
        },
        {
            Header: 'Location',
            accessor: 'location.name',
        },
        {
            Header: 'quantity',
            accessor: 'quantity',
        },

        {
            Header: 'Action',
            Cell: ({ row }) => {
                console.log('row', row?.original);
                return (
                    <div className="flex flex-row items-center gap-2">
                        <Trash2
                            color="red"
                            onClick={async () => {
                                await deleteWriteOffSecond(row.original._id);
                                await getWriteOffSeconds({
                                    page: 1,
                                    populate: true,
                                });
                            }}
                        />
                    </div>
                );
            },
        },
    ];

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            getWriteOffSeconds({ search: search, page: 1, populate: true });
        }, 300),
        []
    );

    useEffect(() => {
        getWriteOffSeconds({ page, populate: true });
    }, [page]);

    return (
        <PageWithCard>
            <div className="p-4">
                <TableWithHeadingAndGlobalSearch
                    heading="View Write Off Seconds"
                    columns={cols}
                    searchFunction={debouncedSearch}
                    loading={loading}
                    data={
                        writeOffData?.docs?.length > 0 ? writeOffData.docs : []
                    }
                />
                <PaginationClassic
                    paginationDetails={writeOffData}
                    setPage={setPage}
                />
            </div>
        </PageWithCard>
    );
};

export default ViewWriteOffSecond;
